/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import Box from '@material-ui/core/Box';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state';
import React from 'react';

export interface CustomPopoverProps {
   actionElem: React.ReactNode;
   content: React.ReactNode;
   id?: string;
}

const CustomPopover = (props: CustomPopoverProps) => {
   return (
      <PopupState variant="popover" popupId="demo-popup-popover">
         {(popupState) => (
            <div>
               <div onClick={(e) => e.stopPropagation()}>
                  <div id={props.id} {...bindTrigger(popupState)}>
                     {props.actionElem}
                  </div>
               </div>
               <Popover
                  {...bindPopover(popupState)}
                  anchorOrigin={{
                     vertical: 'bottom',
                     horizontal: 'right',
                  }}
                  transformOrigin={{
                     vertical: 'top',
                     horizontal: 'right',
                  }}
               >
                  <Box p={0.5} onClick={popupState.close}>
                     <Typography component={'div'}>{props.content}</Typography>
                  </Box>
               </Popover>
            </div>
         )}
      </PopupState>
   );
};

export default CustomPopover;
